/// <reference path="../include.ts" />

namespace project_common {

	import DataParser = project_common.DataParser;

	export class DomUtil {

		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static loadImageToSrc(target:JQuery, url:string):void {
			if (DomUtil.isLazyLoadingEnabled) {
				target.attr('data-src', url);
				target.addClass('lazyload');
			} else {
				target.attr('src', url);
			}
		}

		public static clearImageFromSrc(target:JQuery):void {
			target.attr('src', '');
			if (DomUtil.isLazyLoadingEnabled) {
				target.removeAttr('data-src');
				target.removeClass('lazyload lazyloaded');
			}
		}

		public static loadImageToBackground(target:JQuery, urls:string[]):void {
			const value = 'url(\'' + urls.join('\'), url(\'') + '\')';
			target.css('background-image', value);
		}

		public static clearImageFromBackground(target:JQuery):void {
			target.css('background-image', '');
			if (DomUtil.isLazyLoadingEnabled) {
				target.removeAttr('data-bg');
				target.removeClass('lazyload lazyloaded');
			}
		}

		public static setHtml(textField:JQuery, value:string):void {
			if (value) {
				value = DataParser.nl2br(value);
				value = DataParser.addCharClass(value);
				textField.html(value);
			} else {
				textField.html('');
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private static isLazyLoadingEnabled:boolean = false;





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
